import type { JSX } from "react";
export const compose =
  <T>(...fns: ((a: unknown) => unknown)[]) =>
  (component: (props: unknown) => JSX.Element | null) =>
    fns.reduceRight((acc, fn) => fn(acc), component) as T;
